const aws = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:fd6c7584-ec3f-4857-8d8d-9ee9fc4c80bd',
  userPoolId: 'eu-west-1_z7HrmSsZ0',
  userPoolClientId: '62460g6qakfdk6l9aqipfkv9n2',
  productionManagementAppsyncEndpoint: 'https://m7uhc2lyd5ay5gu57vycfz4nni.appsync-api.eu-west-1.amazonaws.com/graphql',
};
export default aws;
